export default __webpack_public_path__ + "static/media/padlock.1713433e.svg";